export function isValidTime(time) {
    if (!time || typeof time !== 'string' || time.trim() === '') {
        return false;
    }
    const trimmed = time.trim();
    const timePattern = /^(\d{1,2}):(\d{1,2})$|^\d+$/;
    if (!timePattern.test(trimmed)) {
        return false;
    }
    if (trimmed.includes(':')) {
        const [minutes, seconds] = trimmed.split(':');
        const mins = parseInt(minutes, 10);
        const secs = parseInt(seconds, 10);
        return !isNaN(mins) && !isNaN(secs) && mins >= 0 && secs >= 0 && secs < 60;
    }
    const numValue = parseInt(trimmed, 10);
    return !isNaN(numValue) && numValue >= 0;
}
export function timeToSeconds(time) {
    if (!time || typeof time !== 'string' || time.trim() === '') {
        return 0;
    }
    const trimmed = time.trim();
    if (trimmed.includes(':')) {
        const [minutes, seconds] = trimmed.split(':');
        const mins = parseInt(minutes, 10);
        const secs = parseInt(seconds, 10);
        // Validate that both parts are valid numbers
        if (isNaN(mins) || isNaN(secs)) {
            return 0;
        }
        return Math.max(0, (mins * 60) + secs);
    }
    const totalSeconds = parseInt(trimmed, 10);
    return isNaN(totalSeconds) ? 0 : Math.max(0, totalSeconds);
}
export function formatDuration(seconds) {
    if (typeof seconds !== 'number' || isNaN(seconds) || !isFinite(seconds) || seconds <= 0) {
        return '0:00';
    }
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}
export function formatTimeInput(value) {
    if (!value || typeof value !== 'string' || value.trim() === '') {
        return null;
    }
    const trimmed = value.trim();
    if (trimmed.includes(':')) {
        const [minutes, seconds] = trimmed.split(':');
        const mins = parseInt(minutes, 10);
        const secs = parseInt(seconds, 10);
        // Validate both parts are valid numbers
        if (!isNaN(mins) && !isNaN(secs) && mins >= 0 && secs >= 0 && secs < 60) {
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        }
    }
    else {
        const totalSeconds = parseInt(trimmed, 10);
        if (!isNaN(totalSeconds) && totalSeconds >= 0) {
            const mins = Math.floor(totalSeconds / 60);
            const secs = totalSeconds % 60;
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        }
    }
    return null;
}
export function vttTimeToMmSs(vttTime) {
    if (!vttTime || typeof vttTime !== 'string') {
        return '0:00';
    }
    const parts = vttTime.split(':');
    if (parts.length !== 3) {
        return '0:00';
    }
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const secondsFloat = parseFloat(parts[2]);
    if (isNaN(hours) || isNaN(minutes) || isNaN(secondsFloat)) {
        return '0:00';
    }
    if (hours < 0 || minutes < 0 || secondsFloat < 0) {
        return '0:00';
    }
    const seconds = Math.floor(secondsFloat);
    const totalMinutes = hours * 60 + minutes;
    return `${totalMinutes}:${seconds.toString().padStart(2, '0')}`;
}
